module.exports = __webpack_public_path__ + "static/media/asset-manager-logo.8c62e58e.svg";